import "react-multi-carousel/lib/styles.css";
import coastal from "../assets/img/SmallLogo.png";
import colorSharp from "../assets/img/color-sharp.png";
import Coastallineimg from "../assets/img/SmallLogo.png";
import sujenimg from "../assets/img/aboutme.png";

const coastalimg = coastal;
const coastline = Coastallineimg;
export const Aboutus = () => {
  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="about-bx wow zoomIn" id="aboutus">
              <div
                className="row align-items-center justify-content-between
"
              >
                <div className="col-lg-6 col-md-5 text-start px-4">
                  {" "}
                  <h2>About Me</h2>
                  <p>
                    A skilled Full Stack Software Engineer with experience building scalable web applications using Angular, React, Next.js, Node.js, and Express.js. <br></br><br></br>Experienced in fintech and enterprise software development, delivering high-performance, user-focused solutions while collaborating with teams and clients across the full development lifecycle.






                  </p>
                </div>
                <div className=" col-lg-5 col-md-6 px-4">
                  <img src="https://i.ibb.co/NdjhwBQb/Lively-Bubbles-Photo-Collage-1-Photoroom.png" className="img-fluid"></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
